import { render, staticRenderFns } from "./ykyjList.vue?vue&type=template&id=603b5912&scoped=true&"
import script from "./ykyjList.vue?vue&type=script&lang=js&"
export * from "./ykyjList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603b5912",
  null
  
)

export default component.exports